import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const CarouselSectionPortraitImageStyle: MediaSetting[] = [
  {
    screen: Screen.XXXS,
    key: '2_3_540',
    width: 540,
    height: 810,
    ratio: 0.66,
  },
];
